import { Controller } from "@hotwired/stimulus"

// Floating label controller pour labels flottants modernes
// Usage:
//   <div data-controller="floating-label">
//     <label class="floating-label">Nom</label>
//     <input type="text" data-action="input->floating-label#updateLabel">
//   </div>
export default class extends Controller {
  updateLabel(event) {
    const input = event.target
    const label = input.previousElementSibling

    if (!label) return

    if (input.value.length > 0) {
      label.classList.add('floating-label-active')
    } else {
      label.classList.remove('floating-label-active')
    }
  }
}
